export default {
  props: ['title', 'image', 'id', 'isStudent', 'academicMainId', 'academicMainTypeId'],
  data() {
    return {
      isEditing: false
    };
  },
  methods: {
    editTitle() {
      this.isEditing = true;
    },
    fileUpload() {
      this.$refs.fileInput.$refs.input.click();
    },
    getDevice() {
      if (window.innerWidth <= 768) {
        return 'mobile';
      }

      if (window.innerWidth <= 1024) {
        return 'tablet';
      }

      return 'desktop';
    },
    getImageDynamicHeight() {
      if (this.getDevice() === 'mobile') {
        return '200';
      }

      if (this.getDevice() === 'tablet') {
        return '300';
      }

      return '350';
    },
    selectedImage(image) {
      if (image) {
        this.$nuxt.$emit('management-section', {
          type : 'changeBanner',
          data : {
            file : image,
            id   : this.id
          }
        });
      }
    },
    excludeImage() {
      this.$nuxt.$emit('management-section', {
        type : 'excludeBanner',
        data : {
          file : null,
          id   : this.id
        }
      });
    },
    emitBlur(event) {
      this.$nuxt.$emit('management-section', {
        type : 'changeBannerTitle',
        data : {
          title : event.target.value,
          id    : this.id
        }
      });

      this.isEditing = false;
    }
  }
};
